export default "__VITE_ASSET__2ffb7475__"